import { Grid, Row, Col } from '@zendeskgarden/react-grid';
import React from 'react';
import styled from 'styled-components/macro';
import PublicPage from 'components/PublicPages/PublicPage';
import { variables } from 'theme/variables';
const {
  media_sm,
  public_app_max_width
} = variables;

export const LandingSectionInner = styled('div')`
  max-width: ${public_app_max_width};
  margin: 0 auto;
  padding: ${(props) => '0' || '0'} 15px 50px;
  @media ${media_sm} {
    padding: ${(props) => '0' || '0'} 40px 50px;
  }
`;


export const InlineSection = styled('div')`
  margin-bottom: 0;
  @media ${media_sm} {
    margin-bottom: 60px;
  }
`;

export const CompanyPage = styled(PublicPage)`
  padding-top: 0px;
`;

